import { fabric } from "fabric"
import { timelineStore } from "@/store/timelineStore";

export default class EditorCanvas{
  editorFabric
  editorObj
  timelineStoreState
  rectMap = {}
  listenActiveClipList = []
  constructor(editorObj){
    this.timelineStoreState = timelineStore();
    this.initEdutorCanvas()
    this.editorObj = editorObj
  }

  initEdutorCanvas(){
    const canvas = document.getElementById('editorCanvas');
    if(this.timelineStoreState.templateStyle === "down"){
      canvas.width = 1080
      canvas.height = 1920
    }
    this.editorFabric = new fabric.Canvas('editorCanvas', {
      fireRightClick: true, // 启用右键
      stopContextMenu: true, // 禁止默认右键菜单
      controlsAboveOverlay: true, // 超出clipPath后仍然展示控制条
      selection: false,
      hoverCursor: "grab",
      centeredScaling: true, // 中心点缩放
      preserveObjectStacking: true,
    });
    this.editorFabric.on('mouse:down',(e)=>{
      if(!e.target){
        this.timelineStoreState.setActiveClipName(null)
      } else {
        const clip_name = e.target.clip_name
        const type = clip_name.split("_")[1];
        if(type === 'background'){
          this.timelineStoreState.setActiveClipName(null)
        } else {
          this.timelineStoreState.setActiveClipName(clip_name)
        }
      }
    })
  }

  // 画框
  drawRect(x, y , width, height, clip_name, zindex = 0, rotate_angle = 0, scaleX = 1, scaleY = 1){
    const rect = new fabric.Rect({
      left: x,
      top: y,
      fill: "",
      width: width,
      height: height,
      objectCaching: false,
      stroke: 'lightgreen',
      strokeWidth: 0,
      originX: 'center',
      originY: 'center',
      angle: rotate_angle,
      selectable: false,
      scaleX,
      scaleY
    });
    rect.set('clip_name' , clip_name)
    rect.set('zIndex' , zindex)
    const type = clip_name.split("_")[1];
    if (type === "text" || type === "ai") {
      rect.setControlVisible("mt", false); // 上
      rect.setControlVisible("mb", false); // 下
      rect.setControlVisible("ml", false); // 左
      rect.setControlVisible("mr", false); // 右
    }
    if(type === 'background' || type === 'caption'){
      rect.set('selectable' , false)
      rect.set('hoverCursor', 'default')
    } else {
      rect.set('selectable' , true)
    }

    // 移动方法
    const moveRect = (e) => {
      const {br, tl} = {...rect.lineCoords}
      const x = ( tl.x + br.x) / 2
      const y = (tl.y + br.y) / 2
      this.editorObj.updateClipPositon(rect.clip_name, x, y)
      this.listenActiveClipList.forEach((fn) => fn(rect))
    }
    // let previous = 0 // 节流无法解决异步渲染拖影问题
    
    // ----------- 暂时不用控制框-------
    // rect.on('mousedown', moveRect)
    // rect.on('mouseup', () => {
    //   moveRect(),
    //   this.editorObj.query('serializableJson')
    // })
    // rect.on('moving', moveRect)
    // // 缩放事件
    // rect.on("scaling", (e) =>{
    //   let {clip_name, scaleX, scaleY} = {...rect}
    //   scaleX = scaleX ? scaleX : 1
    //   scaleY = scaleY ? scaleY : 1
    //   this.editorObj.UpdateClipScale(clip_name, scaleX, scaleY)
    // })
    // // 旋转
    // rect.on('rotating', () => {
    //   const {angle, clip_name} = {...rect}
    //   if(!angle) return
    //   this.editorObj.updateClipRotateAngle(clip_name, angle)
    // })
    // ============================================
    this.editorFabric.add(rect)
    // 更改指定图层
    this.editorFabric.moveTo(rect, zindex)
    // 将rect放入map
    this.rectMap[clip_name] = rect
  }

  // clipList 为数组
  drawRects(clipList){
    clipList.forEach(clip => {
      const clip_name = clip.id
      if(this.rectMap[clip_name]){
        this.editorFabric.add(this.rectMap[clip_name])
        new Promise((res) => {
          res()
        }).then(() => {
          this.moveTo(clip_name, this.rectMap[clip_name].zIndex)
        })
      } else {
        this.drawRectByClipName(clip_name)
      }
    });
  }

  // 通过clip_name画框
  drawRectByClipName(clip_name, time = 200){
    // ----------- 暂时不用控制框-------
    // const type = clip_name.split('_')[1];
    // if(type === 'aiAudio') return
    // setTimeout(() => {
    //   let width, height
    //   const clipPositon = this.editorObj.getClipBoundingBox(clip_name)
    //   if(clipPositon?.success === -1){
    //     this.drawRectByClipName(clip_name)
    //     return
    //   }
    //   width = Math.sqrt(
    //     Math.pow((clipPositon.rightTop_x - clipPositon.leftTop_x), 2) + 
    //     Math.pow((clipPositon.rightTop_y - clipPositon.leftTop_y), 2)
    //   )
    //   height = Math.sqrt(
    //     Math.pow((clipPositon.leftBottom_x - clipPositon.leftTop_x), 2) + 
    //     Math.pow((clipPositon.leftBottom_y - clipPositon.leftTop_y), 2)
    //   )
    //   const clipJson = this.editorObj.getClipByName(clip_name)
    //   const scaleX = clipJson.scale_x
    //   const scaleY = clipJson.scale_y
    //   width = width / scaleX
    //   height = height / scaleY 
    //   // 如果已存在相同的框 删了重画
    //   if(!this.rectMap[clip_name]){
         
    //     this.drawRect(clipJson.x, clipJson.y, width, height, clip_name, clipJson.zIndex, clipJson.rotate_angle, scaleX, scaleY)
    //   } else {
    //     this.updateRect(clipJson.x, clipJson.y, width, height, clip_name, clipJson.zIndex, clipJson.rotate_angle, scaleX, scaleY)
    //   }
    // }, time);
  }

  // 根据名字删除clip
  removeRectByClipName(clip_name){
    this.editorFabric.remove(this.rectMap[clip_name])
    delete this.rectMap[clip_name]
  }

  // 移动自定义图层
  moveTo(clip_name, index){
    if(!this.rectMap[clip_name]) return
    this.rectMap[clip_name].zIndex = index
    this.rectMap[clip_name].moveTo(index)
  }

  getRectFromClipName(clip_name = this.timelineStoreState.getActiveClipName) {
    return this.rectMap[clip_name]
  }

  // 根据clipName 控制选中元素
  selectRectByClipName(clip_name) {
    const rect = this.getRectFromClipName(clip_name);
    if (rect) {
      this.editorFabric.setActiveObject(rect);
      this.editorFabric.requestRenderAll();
    } else {
      this.editorFabric.discardActiveObject();
      this.editorFabric.requestRenderAll();
    }
  }

  updateRect(x, y , width, height, clip_name, zindex = 0, rotate_angle = 0){
    const rect = this.getRectFromClipName(clip_name)
    rect.set({
      left: x,
      top: y,
      width,
      height,
      rotate_angle
    })
    rect.setCoords()
    rect.set('zIndex', zindex)
    this.editorFabric.requestRenderAll()
  }

  lockRect(clip_name, val){
    const rect = this.getRectFromClipName(clip_name);
    rect.set({
      lockScalingX: val,
      lockScalingY: val,
      lockMovementX : val,
      lockMovementY: val,
      hasControls : !val
    })
    this.editorFabric.requestRenderAll()
  }
}